import React from 'react';
import FilterPanel from '@spark/ui-components/components/FilterPanel';

const DisponibilidadeMotoristaFilter = ({ loading, onApply, onLimpar, title, filters, collapseOnSearch = false }) => {
  return (
    <FilterPanel
      filters={filters}
      onApply={onApply}
      onLimpar={onLimpar}
      title={title}
      loading={loading}
      defaultCollapsed={true}
      collapseOnSearch={collapseOnSearch}
    />
  );
};

export default DisponibilidadeMotoristaFilter;
